
export class Photo {
    id: number;
    publish: boolean;
    keywords: string;
    name: string;
    owner: string;
    description: string;
    date: string;
    image: string;
    image2: string;
    image3: string;
    selectedImage: string;
    thumbnail: string;
    category: string;
    todo: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.publish = source["publish"];
        this.keywords = source["keywords"];
        this.name = source["name"];
        this.owner = source["owner"];
        this.description = source["description"];
        this.date = source["date"];
        this.image = source["image"];
        this.image2 = source["image2"];
        this.image3 = source["image3"];
        this.selectedImage = source["selectedImage"];
        this.thumbnail = source["thumbnail"];
        this.category = source["category"];
        this.todo = source["todo"];
    }
}
export class Category {
    id: string;
    description: string;
    order: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.description = source["description"];
        this.order = source["order"];
    }
}

export const categories: Category[] = [
    {
        "id": "višnjan",
        "description": "Višnjan mjesto (vizure)",
        "order": 0
    },
    {
        "id": "okolica",
        "description": "Okolica Višnjana (vizure)",
        "order": 1
    },
    {
        "id": "škola",
        "description": "Škola",
        "order": 2
    },
    {
        "id": "višnjanci",
        "description": "Višnjanci",
        "order": 3
    },
    {
        "id": "sport",
        "description": "Sportaši",
        "order": 4
    },
    {
        "id": "događaji",
        "description": "Priredbe i događaji (glazba)",
        "order": 5
    },
    {
        "id": "crkva",
        "description": "Crikva",
        "order": 6
    },
    {
        "id": "ekonomija",
        "description": "Obrtnici, poljoprivrednici, tvrtke, ...",
        "order": 7
    },
    {
        "id": "kartuline",
        "description": "Kartuline",
        "order": 8
    },
    {
        "id": "boskarini",
        "description": "Boškarini",
        "order": 9
    },
    {
        "id": "1919",
        "description": "1919 dolazak talijanskinh vojnika",
        "order": 10
    },
    {
        "id": "familije",
        "description": "Stare familije",
        "order": 11
    },
    {
        "id": "delete",
        "description": "ZA BRISANJE",
        "order": 12
    },
    {
        "id": "todo",
        "description": "TRAŽI SE ORIGINAL",
        "order": 13
    }
]